var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEstablishedOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_12183",
    "data-name": "Group 12183",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.219,
    height: 12.672,
    viewBox: "0 0 15.219 12.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4503",
    "data-name": "Rectangle 4503",
    width: 15.219,
    height: 12.672,
    fill: "#ef7b13"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10995",
    "data-name": "Group 10995",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44557",
    "data-name": "Path 44557",
    d: "M0,168.017c.294-.414.5-.087.81.035a2.279,2.279,0,0,0,.243.084H6.318v.964a.344.344,0,0,0,.34.313c.607.059,1.31-.045,1.928,0a.352.352,0,0,0,.284-.31v-.964h5.265a2.28,2.28,0,0,0,.243-.084c.286-.113.552-.461.791-.03l.016,4.724a1.271,1.271,0,0,1-1.138,1.087l-12.964,0A1.319,1.319,0,0,1,0,172.793Z",
    transform: "translate(0 -161.161)",
    fill: "#ef7b13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44558",
    "data-name": "Path 44558",
    d: "M0,2.97A1.4,1.4,0,0,1,.6,2.1a1.859,1.859,0,0,1,.421-.172h3.4V1.146A1.32,1.32,0,0,1,5.56.032C6.907-.066,8.377.1,9.736.041a1.355,1.355,0,0,1,1.031,1.1v.786h3.4c.491,0,.985.681,1.024,1.141a13.2,13.2,0,0,1-.045,2.36,1.343,1.343,0,0,1-1.039.919H8.869c0-.263.024-.594-.31-.624-.636-.058-1.366.041-2.012.008-.253.092-.233.392-.229.617H1.083a1.384,1.384,0,0,1-.969-.721L0,5.284ZM9.492,1.279H5.7v.653h3.8Z",
    transform: "translate(0 0)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstablishedOrange);
export default __webpack_public_path__ + "static/media/established_orange.d213d4522823bcea54aca1dbb4f2f342.svg";
export { ForwardRef as ReactComponent };